import * as Sentry from '@sentry/react'
import { deployEnv } from './authMode'

const SENSITIVE_KEYS = ['brief', 'brief_body', 'enhanced_brief', 'question_answers', 'token']

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN_FRONTEND
  if (!dsn) return

  Sentry.init({
    dsn,
    // Was hardcoded 'production', so every preview error landed in the
    // production environment and nothing in Sentry could tell the two apart.
    // `__DEPLOY_ENV__` is baked from VERCEL_ENV at build time (see
    // `src/lib/authMode.ts`) — never mint a second constant for this.
    environment: deployEnv(),
    release: import.meta.env.VITE_BUILD_SHA,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1,
    // Noise from Session Replay choking on cross-origin iframes injected by
    // browser extensions (e.g. Poper Blocker's `iframe.pp-blocker`). Not our code.
    ignoreErrors: [/Blocked a frame with origin/, /cross-origin frame/],
    beforeSend(event) {
      if (event.request?.url) {
        event.request.url = event.request.url.replace(/token=[^&]+/g, 'token=REDACTED')
      }
      if (event.extra) {
        for (const key of SENSITIVE_KEYS) {
          if (key in event.extra) event.extra[key] = '[REDACTED]'
        }
      }
      return event
    },
  })
}

export { Sentry }
